import React from 'react';

export const DoExerciseProgressContext = React.createContext<any>({});

export const withDoExerciseProgressContext = (Component) => (props) => {
  const [pageId, setPageId] = React.useState(null);

  return (
    <DoExerciseProgressContext.Provider value={{ pageId, setPageId }}>
      <Component {...props} />
    </DoExerciseProgressContext.Provider>
  );
};

export const useDoExerciseProgressContext = () => React.useContext(DoExerciseProgressContext);
